import React from 'react';
import { Target, Shield, Users, MapPin, Phone, Mail } from 'lucide-react';

const Nitrokym = ({ usine }) => {
  return (
    <div className="nitrokym">
      {/* Header */}
      <section 
        className="hero"
        style={{
          backgroundImage: 'url(/images/nnitro.jpeg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          position: 'relative',
          minHeight: '500px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <div className="container" style={{ position: 'relative', zIndex: 1, textAlign: 'center' }}>
          <h1 className="hero-title" style={{ color: '#fff', textShadow: '2px 2px 4px rgba(0,0,0,0.3)' }}>{usine.nom}</h1>
          <p className="hero-subtitle" style={{ color: '#dbeafe', textShadow: '1px 1px 2px rgba(0,0,0,0.3)' }}>Usine Spécialisée en Chimie des Chlor-Alkalis</p>
        </div>
      </section>

      {/* Présentation */}
      <section className="section">
        <div className="container">
          <div style={{ maxWidth: '900px', margin: '0 auto' }}>
            <div className="usine-card">
              <div 
                className="usine-image"
                style={{
                 height: '300px',
                backgroundImage: 'url(/images/team-nitro.png)',
                backgroundSize: 'cover',
                backgroundPosition: 'center 20%',
                position: 'relative'
                }}
              />
              <div className="usine-content">
                <h2 className="usine-name">{usine.nom}</h2>
                <p className="usine-specialite">{usine.specialite}</p>
                
                <div style={{ margin: '30px 0' }}>
                  <p style={{ lineHeight: '1.8', marginBottom: '20px' }}>
                    <strong>Nitrokym</strong>, fondée en {usine.fondation}, est une unité de production 
                    spécialisée dans la chimie des chlor-alkalis. Notre expertise technique et notre 
                    engagement qualité nous permettent de produire des produits chimiques essentiels 
                    pour diverses industries.
                  </p>
                  
                  <p style={{ lineHeight: '1.8', marginBottom: '20px' }}>
                    Avec plus de {usine.employes} employés qualifiés, nous garantissons une production 
                    continue et de haute qualité, répondant aux normes les plus strictes du secteur.
                  </p>
                </div>

                {/* Infos pratiques */}
                <div style={{ 
                  background: '#f8f9fa', 
                  padding: '25px', 
                  borderRadius: '10px',
                  marginTop: '30px'
                }}>
                  <h3 style={{ color: '#0A2E5C', marginBottom: '20px', fontSize: '20px' }}>
                    Informations Pratiques
                  </h3>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '15px' }}>
                    <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                      <MapPin size={18} color="#007BFF" style={{ marginTop: '3px' }} />
                      <div>
                        <strong>Adresse :</strong><br />
                        {usine.adresse}<br />
                        {usine.ville}
                      </div>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                      <Phone size={18} color="#007BFF" />
                      <div>
                        <strong>Téléphone :</strong> {usine.telephone}
                      </div>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                      <Mail size={18} color="#007BFF" />
                      <div>
                        <strong>Email :</strong> {usine.email}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Notre Expertise */}
      <section className="section" style={{ background: '#f8f9fa' }}>
        <div className="container">
          <h2 className="section-title">Notre Expertise</h2>
          <div className="certifications-grid">
            <div className="cert-card">
              <Target size={40} color="#007BFF" style={{ marginBottom: '20px' }} />
              <h3 className="cert-name">Chimie des Chlor-Alkalis</h3>
              <p className="cert-desc">
                Expertise technique avancée dans la production d'acide chlorhydrique, 
                de soude caustique et d'hypochlorite de sodium.
              </p>
            </div>

            <div className="cert-card">
              <Shield size={40} color="#28a745" style={{ marginBottom: '20px' }} />
              <h3 className="cert-name">Qualité Garantie</h3>
              <p className="cert-desc">
                Certification ISO 9001:2015 et contrôles qualité rigoureux à chaque 
                étape de la production.
              </p>
            </div>

            <div className="cert-card">
              <Users size={40} color="#fd7e14" style={{ marginBottom: '20px' }} />
              <h3 className="cert-name">Équipe Qualifiée</h3>
              <p className="cert-desc">
                Équipe technique et opérationnelle expérimentée, formée régulièrement 
                aux dernières normes de sécurité.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Process de Production */}
      <section className="section">
        <div className="container">
          <h2 className="section-title">Notre Processus de Production</h2>
          <div style={{ maxWidth: '1000px', margin: '0 auto' }}>
            <div style={{ 
              display: 'grid', 
              gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
              gap: '30px',
              marginTop: '40px'
            }}>
              {/* Étape 1 */}
              <div style={{ 
                background: 'white', 
                padding: '30px', 
                borderRadius: '10px',
                boxShadow: '0 5px 20px rgba(0,0,0,0.08)',
                textAlign: 'center',
                border: '2px solid #007BFF'
              }}>
                <div style={{
                  width: '60px',
                  height: '60px',
                  background: '#007BFF',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  margin: '0 auto 20px',
                  fontSize: '28px',
                  fontWeight: 'bold',
                  color: 'white'
                }}>
                  1
                </div>
                <h4 style={{ color: '#0A2E5C', marginBottom: '15px', fontSize: '18px', fontWeight: '600' }}>
                  Approvisionnement
                </h4>
                <p style={{ color: '#666', lineHeight: '1.6', fontSize: '14px' }}>
                  Sélection rigoureuse des matières premières auprès de fournisseurs certifiés.
                </p>
              </div>

              {/* Étape 2 */}
              <div style={{ 
                background: 'white', 
                padding: '30px', 
                borderRadius: '10px',
                boxShadow: '0 5px 20px rgba(0,0,0,0.08)',
                textAlign: 'center',
                border: '2px solid #007BFF'
              }}>
                <div style={{
                  width: '60px',
                  height: '60px',
                  background: '#007BFF',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  margin: '0 auto 20px',
                  fontSize: '28px',
                  fontWeight: 'bold',
                  color: 'white'
                }}>
                  2
                </div>
                <h4 style={{ color: '#0A2E5C', marginBottom: '15px', fontSize: '18px', fontWeight: '600' }}>
                  Production
                </h4>
                <p style={{ color: '#666', lineHeight: '1.6', fontSize: '14px' }}>
                  Procédés de fabrication optimisés avec surveillance continue des paramètres.
                </p>
              </div>

              {/* Étape 3 */}
              <div style={{ 
                background: 'white', 
                padding: '30px', 
                borderRadius: '10px',
                boxShadow: '0 5px 20px rgba(0,0,0,0.08)',
                textAlign: 'center',
                border: '2px solid #28a745'
              }}>
                <div style={{
                  width: '60px',
                  height: '60px',
                  background: '#28a745',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  margin: '0 auto 20px',
                  fontSize: '28px',
                  fontWeight: 'bold',
                  color: 'white'
                }}>
                  3
                </div>
                <h4 style={{ color: '#0A2E5C', marginBottom: '15px', fontSize: '18px', fontWeight: '600' }}>
                  Contrôle Qualité
                </h4>
                <p style={{ color: '#666', lineHeight: '1.6', fontSize: '14px' }}>
                  Analyses et contrôles rigoureux à chaque étape pour garantir la conformité.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Équipements */}
      <section className="hero" style={{ background: 'linear-gradient(to right, #0A2E5C, #1e3a8a)' }}>
        <div className="container">
          <h2 className="hero-subtitle">Équipements Modernes</h2>
          <p className="hero-text">
            Nitrokym dispose d'équipements de production de dernière génération, 
            permettant une production efficace et de haute qualité.
          </p>
          <div className="stats-grid" style={{ maxWidth: '600px', margin: '40px auto' }}>
            <div className="stat-item" style={{ background: 'rgba(255,255,255,0.1)', color: 'white' }}>
              <div className="stat-number" style={{ color: 'white' }}>100%</div>
              <div className="stat-label" style={{ color: '#dbeafe' }}>Automatisation</div>
            </div>
            <div className="stat-item" style={{ background: 'rgba(255,255,255,0.1)', color: 'white' }}>
              <div className="stat-number" style={{ color: 'white' }}>24/7</div>
              <div className="stat-label" style={{ color: '#dbeafe' }}>Surveillance</div>
            </div>
            <div className="stat-item" style={{ background: 'rgba(255,255,255,0.1)', color: 'white' }}>
              <div className="stat-number" style={{ color: 'white' }}>ISO 9001</div>
              <div className="stat-label" style={{ color: '#dbeafe' }}>Certifiée</div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Nitrokym;